import React from 'react'
import { Link } from "react-router-dom";

function Start(props) {

  return (
    <div>
    <h1>Salaam</h1>
    <p>Struggling to read Arabic?</p>
    <p>No problem. You're at the right place.</p>
    <Link to="/Dashboard">
    <button className="ArticleButtonBox" >Start practising</button>
    </Link>
    <Link to="/About">
    <h3 className="ArticleButtonBox">About</h3>
    </Link>
    </div>
  )
}

export default Start
